import { useEffect } from 'react'
import HeaderImage from '../../../assets/logo1.png'
import Logo from '../../../assets/small_header1.png'
import data from './data'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'
import MicrosoftLogo from '../../../assets/mspartner-logo.svg'
import BrandsCarousel from '../../../components/BrandsCarousel'

const Header = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  return (
    <header id="header" className="dummy-header">
      <div className="container header__container">
        {/* <br /> */}
        {/* Google Trust Badge */}
        <div className="google-trust-badge" data-aos="fade-down">
          <div className="google-logo-flat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="18"
              height="18"
              aria-label="Google review"
            >
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
          </div>
          <div className="google-rating-info">
            <div className="google-stars">★★★★★</div>
            <p>Rated <strong>4.9 / 5</strong> by 120+ students</p>
          </div>
        </div>

        <div className="header__profile" data-aos="fade-in">
          <img src={HeaderImage} alt="Header Portrait" />
        </div>

        <div className='row'>
          <div className='column'>
            <a href='https://int-elligence.co.uk'>
              <img className="imgl" src={Logo} alt="Logo" />
            </a>
          </div>
          <span className="separator">|</span>
          <div className='microsoft_logo'>
            <img src={MicrosoftLogo} alt="Microsoft Partner Logo" />
          </div>
        </div>

        <center>
          <h2 className="header-title">SkillBridge</h2>
          <h4 className="header-subtitle">An IntElligence Tech Solutions Company</h4>
        </center>

        <p className="header-desc">
          Bridging skills, industry and careers through real-world training and internship programs.<br /><br />
          SkillBridge is the training and internship certificate program division of Int-Elligence Tech Solutions Plc, preparing students, professionals, and career switchers for real-world UK tech roles.
        </p>

        <div className="header__cta" data-aos="fade-up">
          <a href="#contact" className='btn primary'>Get in touch</a>
          <a href="#portfolio" className='btn light'>Our Programs</a>
        </div>

        <div className="header__socials">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>

      {/* Infinite Brands Scroller Carousel */}
      <BrandsCarousel />
    </header>
  )
}

export default Header